import React from 'react';
import * as Yup from 'yup';
import { PropTypes } from 'prop-types';
import Textarea from '@atoms/Textarea';

export const editProfileBioValidationSchema = {
    description: Yup.string()
        .max(600, 'Your bio must be 600 characters or less.')
        .nullable(),
};

const EditProfileFieldsBio = ({
    label = 'Introduce yourself by adding a summary about your expertise and interests.',
}) => (
    <>
        <Textarea label={label} name="description" charCount={600} rows={9} />
    </>
);

EditProfileFieldsBio.propTypes = {
    label: PropTypes.string,
};

export default EditProfileFieldsBio;
